module.exports = __webpack_public_path__ + "img/добавить схему.88c72890.jpg";